<template>
  <SearchBar>
    <el-date-picker
      size="small"
      v-model="newMonth"
      type="month"
      :placeholder="this.$t('search.selMonth')"
      :change="handleChangeSearchType"
      value-format="yyyyMM"
    >
    </el-date-picker>
    <el-select
      size="small"
      :placeholder="this.$t('search.selRobot')"
      style="margin-left:15px"
      :value="searchParams.robotID"
      @change="handleChangeRobot"
    >
      <el-option :label="this.$t('search.selRobot')" value=""></el-option>
      <el-option v-for="robot in robotList" v-bind:key="robot.id" v-bind:label="robot.name" v-bind:value="robot.id">
      </el-option>
    </el-select>
    <el-select
      size="small"
      :placeholder="this.$t('search.selFunction')"
      style="margin-left:15px"
      :value="searchParams.functionID"
      @change="handleChangeFunction"
    >
      <el-option :label="this.$t('search.selFunction')" value=""></el-option>
      <el-option v-for="fun in functionList" v-bind:key="fun.functionID" v-bind:label="fun.functionName" v-bind:value="fun.functionID">
      </el-option>
    </el-select>
    <el-button-group>
      <el-button size="small" type="primary" @click="handleSearch" style="margin-left: 15px;">{{this.$t('search.search')}}</el-button>
      <el-button size="small" @click="handleReset">{{this.$t('search.reset')}}</el-button>
    </el-button-group>
  </SearchBar>
</template>

<script>
import SearchBar from "@/components/common/SearchBar.vue";
import { list,listFunction } from "@/api/robot";
import { mapState } from "vuex";

export default {
  name: "SearchCriterial",
  components: { SearchBar },
  props: {
    handleReset: Function,
    searchParams: Object,
    handleChangeSearchParams: Function,
    handleSearch: Function
  },
  data: () => {
    return {
      functionList: [],
      robotList: []
    };
  },
  mounted() {
    this.getSelectItem();
  },
  methods: {
    getSelectItem() {
      listFunction({
        userID: this.accountInfo.userID
      }).then(response => {
        this.functionList = response.data.items;
      });

      list({
        userID: this.accountInfo.userID
      }).then(response => {
        this.robotList = response.data.items;
      });
    },
    handleChangeSearchType(val) {
      this.handleChangeSearchParams({ ...this.searchParams, searchType: val });      
    },
    handleChangeFunction(val) {
      this.handleChangeSearchParams({ ...this.searchParams, functionID: val });      
    },
    handleChangeRobot(val) {
      this.handleChangeSearchParams({ ...this.searchParams, robotID: val });      
    }
  },
  computed: {
    ...mapState(["accountInfo"]),
    newMonth: {
      get() {
        return this.searchParams.searchType;
      },
      set(val) {
        this.handleChangeSearchParams({
          ...this.searchParams,
          searchType: val
        });
      }
    }
  }
};
</script>
